import DynamicWindowService from '@/core/application-dictionary/components/DynamicWindow/dynamic-window.service';
import AccessLevelMixin from '@/core/application-dictionary/mixins/AccessLevelMixin';
import { AccountStoreModule } from '@/shared/config/store/account-store';
import { WindowStoreModule } from '@/shared/config/store/window-store';
import { Component, Inject, Mixins, Vue } from 'vue-property-decorator';
import DashboardWidget from '../dashboard-widget.vue';

const VendorTransactionInfoProps = Vue.extend({
  props: {
    title: String
  }
});

@Component({
  components: {
    DashboardWidget
  }
})
export default class VendorTransactionInfo extends Mixins(AccessLevelMixin, VendorTransactionInfoProps) {

  @Inject('dynamicWindowService')
  private commonService: (baseApiUrl: string) => DynamicWindowService;

  loading: boolean = false;

  transactions: any[] = [];

  get vendorId() {
    return AccountStoreModule.vendorInfo.id;
  }

  onRowClick(row: any) {
    let menuId = null;

    if (this.isContract(row)) {
      console.log('Zoom to Contract window. ID:', row.id);
      menuId = 2030902;
    } else if (this.isInvoice(row)) {
      console.log('Zoom to Invoice Verification window. ID:', row.id);
      menuId = 44301;
    } else if (this.isPurchaseOrder(row)) {
      console.log('Zoom to Supplier Order window. ID:', row.id);
      menuId = 2030901;
    }

    if (menuId) {
      this.openPage(menuId, row.id);
    }
  }

  created() {
    if (this.vendorId) {
      this.retrieveTransactions();
    }
  }

  isContract(data: any) {
    return data.docType === 'Contract';
  }

  isInvoice(data: any) {
    return data.docType === 'Invoice';
  }

  isPurchaseOrder(data: any) {
    return data.docType === 'Purchase Order';
  }

  async openPage(menuId: number, recordId: number) {
    const actionUrl = await this.commonService('/api/ad-menus/full-path').find(menuId);
    if (actionUrl) {
      const timestamp = Date.now();
      WindowStoreModule.setWatchlistQuery(`id.equals=${recordId}`)
        .then(() => {
          this.$router.push({
            path: actionUrl,
            query: {
              t: `${timestamp}`
            }
          });
        });
    }
  }

  private retrieveTransactions() {
    this.loading = true;
      console.log('Retrieve transaction. vendor: ', this.vendorId);
    this.commonService(`api/c-vendors/${this.vendorId}/transactions`)
      .retrieve()
      .then(res => this.transactions = res.data)
      .catch(err => {
        console.error('Failed to get vendor transaction info', err);
      })
      .finally(() => this.loading = false);
  }
}